/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Button } from '@3plearning/react-components';
import { FooterWrapper } from './styled';
import { dismissModal } from '../../containers/modal-manager/modal-manager-actions';
import { AssignIcon } from '../../helpers/icon-dictionary';
import {
  assignLearningGapsPerStudent,
  updateLearningJourneysByState
} from '../../containers/link-upf-modal/link-upf-modal-actions';
import { showToast } from '../toast/toast-action';
import { CHECKED, DISABLED } from '../checkbox/constants';

const LearningGapsModalFooter = (props) => {
  const { i18n, showAssignAll } = props;
  const dispatch = useDispatch();
  const selectedProduct = useSelector(state => state.product, shallowEqual);
  const { selectedClassRoom } = useSelector(state => state.UPFAssignReducer);
  const { isLoading, isLoadingLJ, learningJourneys } = useSelector(state => state.linkUpfModalReducer);
  let totalLearningJourneysChecked = 0;
  const studentsToAssign = showAssignAll && Object.entries(learningJourneys)
    .reduce((students, [studentId, ljs]) => {
      const checkedLearningJourneys = ljs.filter(lj => lj.checkboxState === CHECKED);
      if (checkedLearningJourneys.length) {
        totalLearningJourneysChecked += checkedLearningJourneys.length;
        return [
          ...students,
          {
            studentId: Number(studentId),
            learningJourneys: checkedLearningJourneys.map(lj => ({
              id: lj.id,
              courseId: lj.courseId,
              courseVersion: lj.courseVersion
            }))
          }
        ];
      }
      return students;
    }, []);

  const handleAssignAll = async () => {
    const hasAssigned = await dispatch(assignLearningGapsPerStudent({
      productId: selectedProduct && selectedProduct.id,
      classroomId: selectedClassRoom.value,
      students: studentsToAssign
    }));
    if (hasAssigned) {
      dispatch(
        showToast(
          <span>{totalLearningJourneysChecked}&nbsp;{i18n.t`Understanding, Practice and Fluency activities assigned to selected students.`}</span>,
          'success'
        )
      );
      dispatch(updateLearningJourneysByState(CHECKED, DISABLED));
    }
  };

  return (
    <FooterWrapper>
      {showAssignAll &&
        <Button
          onClick={handleAssignAll}
          primary
          alignIcon="LEFT"
          icon={AssignIcon}
          text={i18n.t`Assign all selected`}
          type={Button.LOZENGE}
          disabled={isLoading || isLoadingLJ || !totalLearningJourneysChecked}
        />
      }
      <Button
        onClick={() => {
          dispatch(dismissModal());
        }}
        primary
        text={i18n.t`Done`}
        type={Button.LOZENGE}
      />
    </FooterWrapper>
  );
};

LearningGapsModalFooter.propTypes = {
  i18n: PropTypes.object,
  showAssignAll: PropTypes.bool
};

export default LearningGapsModalFooter;
